export const SIGN_IN_PAGE = {
  ABSOLUTE_PATH: "/sign-in",
  FORM_PATH: "/meta-data",
  TITLE: "Sign in",
};
